// src/stone/icons/DollarPaymentLink2X.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var DollarPaymentLink2X = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M20.136 2.667c-9.613 0-17.47 7.809-17.47 17.333h-2C.667 9.357 9.434.667 20.137.667a19.59 19.59 0 0 1 17.421 10.628l-1.78.91a17.59 17.59 0 0 0-15.64-9.538M19.864 37.333c9.613 0 17.47-7.809 17.47-17.333h2c0 10.643-8.767 19.333-19.47 19.333a19.59 19.59 0 0 1-17.42-10.628l1.78-.91a17.59 17.59 0 0 0 15.64 9.538" }),
      /* @__PURE__ */ jsx("path", { d: "m37.778 4.125-1.03 8.686-7.887-1.203.301-1.977 5.843.891.786-6.633zM3.252 27.189l7.887 1.203-.301 1.977-5.843-.891-.786 6.633-1.986-.236zM21.08 8.167V31h-2V8.167z" }),
      /* @__PURE__ */ jsx("path", { d: "M19.096 11.17c2.343-.16 5.021.415 6.408 1.143l.886.464-.93 1.771-.885-.464c-1.01-.53-3.31-1.058-5.343-.919-1.01.07-1.83.296-2.369.659-.483.325-.776.776-.776 1.513 0 .911.386 1.488 1.072 1.968.754.528 1.802.89 3.028 1.28l.255.08c1.088.345 2.31.732 3.263 1.32 1.095.673 1.975 1.698 1.975 3.294 0 1.398-.488 2.516-1.372 3.314-.852.77-1.982 1.161-3.144 1.327-2.313.332-5.12-.173-7.363-.947l-.946-.326.653-1.891.945.326c2.075.716 4.544 1.128 6.428.859.937-.135 1.635-.424 2.087-.832.42-.38.712-.936.712-1.83 0-.694-.32-1.158-1.023-1.592-.735-.452-1.73-.768-2.904-1.142l-.173-.055c-1.173-.373-2.523-.814-3.568-1.546-1.113-.78-1.926-1.921-1.926-3.607 0-1.433.651-2.493 1.66-3.172.952-.642 2.171-.915 3.35-.995" })
    ]
  }
);
var DollarPaymentLink2X_default = DollarPaymentLink2X;

export {
  DollarPaymentLink2X,
  DollarPaymentLink2X_default
};
